export { default } from './BorrowingBibBrief';



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingBibBrief/index.js